<div *ngIf="(cmsBlock$ | async)" class="full-height" [innerHTML]="sanitizer.bypassSecurityTrustHtml((cmsBlock$ | async).content)"></div>
